const TOKEN_KEY_NAME = 'auth_token'
const AUTO_LOGOUT = 'auto_logout';
const IS_MOBILE = 'mobile';
const LANG = 'lang';

import router from "../../router";

export default {

    login(context, credentials, success, error) {
        context.$http.post('auth/login', credentials,{credentials:true}).then(
            (response) => {
                localStorage.setItem(TOKEN_KEY_NAME, response.body.token);

                if (response.body.auto_logout) {
                    localStorage.setItem(AUTO_LOGOUT, true);
                }

                if (response.body.is_mobile) {
                    localStorage.setItem(IS_MOBILE, true);
                    localStorage.setItem(LANG, 'en');
                }

                success(response)
            },
            (response) => {
                // this.logout() //TODO It is necessary?
                error(response)
            }
        )
    },

    signup() {

    },
    clearLocalStorage() {
        localStorage.removeItem(IS_MOBILE);
        localStorage.removeItem(TOKEN_KEY_NAME);
        localStorage.removeItem(AUTO_LOGOUT);
    },
    logout(context, success) {
        let _this = this;
        context.$http.abortPrevRequests();
        // context.$http.post('auth/logout').then((response) => {
                _this.clearLocalStorage();
                success();
            // }
        // );
    },
    getAuthHeader()
    {
        var token = localStorage.getItem(TOKEN_KEY_NAME)

        return token ? 'Bearer ' + token : '';
    },
    isLogged() {
        return localStorage.getItem(TOKEN_KEY_NAME) !== null;
    },
    isMobile() {
        return localStorage.getItem(IS_MOBILE) !== null;
    },
    markUnavailable() {
        this.unavailable = true;
    },
    isUnavailable() {
        return this.unavailable;
    },
    isAutoLogout() {

    }
}


// WEBPACK FOOTER //
// ./src/services/auth/index.js